import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'

import { initI18N } from '../../i18next';
import { capturePromoFromUrl } from '../common/js/promo-utility';

// cart.bundle.js loads on every page (baseof), so this is the single place a
// ?promo= link is persisted to the bfx-promo cookie for the whole web funnel.
capturePromoFromUrl();

const container = document.querySelector("div[id^='cart-app']");

initI18N().then(() => {
    const root = createRoot(container);
    root.render(<App />);
});